(() => {
  const by = (selector, parent = document) => parent.querySelector(selector);
  const all = (selector, parent = document) => [...parent.querySelectorAll(selector)];

  const menuButton = by('[data-menu-toggle]');
  const menu = by('[data-main-nav]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
    });
  }

  const updateQuantity = (button, amount) => {
    const input = by('input', button.parentElement);
    if (!input) return;
    input.value = Math.max(Number(input.min || 1), (Number(input.value) || 1) + amount);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };
  all('[data-quantity-minus]').forEach(button => button.addEventListener('click', () => updateQuantity(button, -1)));
  all('[data-quantity-plus]').forEach(button => button.addEventListener('click', () => updateQuantity(button, 1)));
  all('[data-cart-quantity-minus]').forEach(button => button.addEventListener('click', () => updateQuantity(button, -1)));
  all('[data-cart-quantity-plus]').forEach(button => button.addEventListener('click', () => updateQuantity(button, 1)));

  const galleryImage = by('.product-gallery__image');
  all('[data-gallery-image]').forEach(button => button.addEventListener('click', () => {
    if (!galleryImage) return;
    galleryImage.src = button.dataset.galleryImage;
    all('[data-gallery-image]').forEach(item => item.classList.remove('is-active'));
    button.classList.add('is-active');
  }));

  const productForm = by('[data-product-form]');
  if (productForm) {
    const variantsNode = by('[data-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const selects = all('[data-product-option]', productForm);
    const variantInput = by('[data-variant-id]', productForm);
    const addButton = by('[data-add-to-cart]', productForm);
    const status = by('[data-form-status]', productForm);
    const price = by('[data-product-price]');
    const moneyFormat = document.documentElement.dataset.moneyFormat;

    const money = cents => {
      if (!Number.isFinite(cents)) return '';
      return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    };
    const refreshVariant = () => {
      if (!selects.length) return;
      const values = selects.map(select => select.value);
      const variant = variants.find(item => item.options.every((value, index) => value === values[index]));
      if (!variant) return;
      variantInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      addButton.disabled = !variant.available;
      addButton.innerHTML = variant.available ? 'Añadir al carrito <span aria-hidden="true">→</span>' : 'Agotado';
    };
    selects.forEach(select => select.addEventListener('change', refreshVariant));
    productForm.addEventListener('submit', async event => {
      event.preventDefault();
      if (addButton.disabled) return;
      status.textContent = 'Añadiendo…';
      addButton.disabled = true;
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(productForm) });
        if (!response.ok) throw new Error('No se pudo añadir el producto.');
        const cart = await fetch('/cart.js').then(res => res.json());
        all('[data-cart-count]').forEach(count => { count.textContent = cart.item_count; });
        const toast = by('[data-cart-toast]');
        if (toast) { toast.hidden = false; window.setTimeout(() => { toast.hidden = true; }, 4800); }
        status.textContent = 'Añadido al carrito.';
      } catch (error) {
        status.textContent = 'No se ha podido añadir. Inténtalo de nuevo.';
      } finally {
        addButton.disabled = false;
      }
    });
  }
})();
